import { get } from 'lodash-es';

export const selectSearchData = (state) => get(state, 'searchData', '');
export const selectSearchPerformed = (state) => get(state, 'searchPerformed');
